import { QUOTE_QUESTIONS } from '../AppConstants';
import { IDriver, IIncidentInfo } from '../classes/Domain';

/**
 * Qualitas ТЗ V / Q23: GDD attestation checkbox is allowed only when
 * reported incidents are still compatible with "zero or one … PD only".
 * Not a full eVolve IsGdd clone — portal UX gate only; rate still uses IsGdd.
 */

const HEAVY_INCIDENT_PATTERN =
    /injur|bodily|alcohol|narcotic|dui|dwi|suspend|revok|hit\s*and\s*run|felony|homicide|manslaughter/i;

export function collectReportedIncidents(drivers: Array<IDriver> | null | undefined): IIncidentInfo[] {
    if (!drivers || drivers.length === 0) {
        return [];
    }

    const yes = QUOTE_QUESTIONS.YES_NO.YES;
    const result: IIncidentInfo[] = [];

    for (const driver of drivers) {
        if (!driver || driver.accidentsViolations !== yes) {
            continue;
        }
        const incidents = driver.incidents || [];
        for (const incident of incidents) {
            if (incident && incident.violationCode) {
                result.push(incident);
            }
        }
    }

    return result;
}

export function isHeavyGddDisqualifyingIncident(incident: IIncidentInfo): boolean {
    const haystack = [
        incident.category,
        incident.violation,
        incident.incidentDescription
    ].filter(Boolean).join(' ');

    return HEAVY_INCIDENT_PATTERN.test(haystack);
}

/** True when checkbox may be shown/enabled (0 or 1 light incident; no heavy). */
export function isGddAttestationEligible(drivers: Array<IDriver> | null | undefined): boolean {
    const incidents = collectReportedIncidents(drivers);
    if (incidents.some(isHeavyGddDisqualifyingIncident)) {
        return false;
    }
    return incidents.length <= 1;
}
